import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PortalExceptionHandlingHttpInterceptor } from './exception-handling-http-interceptor';

@NgModule({
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PortalExceptionHandlingHttpInterceptor,
            multi: true
        }
    ],
})
export class PortalExceptionHandlingModule { }
